import Modal from "./bootstrap-5.3.2/modal.js";
import Swiper from "./swiper-bundle.min.js";
import "./aos.js";
import "./bootstrap-datepicker.min.js";
import Swal from "./sweetalert2.min.js";
window.Swal = Swal;
import videojs from "./video.min.js";
window.videojs = videojs;
import { gsap } from "./gsap-3.14.1/gsap.min.js";
import { ScrollTrigger } from "./gsap-3.14.1/ScrollTrigger.min.js";
import Lenis from "lenis";

window.Modal = Modal;
window.Lenis = Lenis;

// Comprehensive fallback to ensure Swiper is globally available
// Swiper 11+ via Webpack import might be the constructor itself,
// have it under .default, or have already attached it to window.
window.Swiper = Swiper.default || Swiper || window.Swiper;

// Make GSAP globally available
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);
